<div class="latlng-overlay" (click)="togglePrecision()" style="cursor: pointer;">
    {{ latlngString }}
</div>